import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'

import { FootnoteComponent } from './FootnoteComponent'

export interface FootnoteOptions {
  HTMLAttributes: Record<string, any>
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    footnote: {
      /**
       * Set a footnote
       */
      setFootnote: (options: { footnoteNum: number }) => ReturnType
      /**
       * Unset a footnote
       */
      unsetFootnote: () => ReturnType
    }
  }
}

export const inputRegex = /!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\)/

export const Footnote = Node.create<FootnoteOptions>({
  name: 'footnote',
  group: 'inline',
  inline: true,
  content: 'inline*',
  atom: true,
  draggable: false,
  selectable: false,
  isolating: true,
  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },
  addAttributes() {
    return {
      ...this.parent?.(),
      'data-footnote-num': {
        default: null,
        parseHTML: (element) => {
          console.log('element: ', element)
          return element.getAttribute('data-footnote-num')
        },
        renderHTML: (attributes) => {
          console.log('attributes: ', attributes)
          return {
            'data-footnote-num': attributes['data-footnote-num'],
          }
        },
      },
    }
  },
  parseHTML() {
    return [
      {
        tag: 'sup',
      },
    ]
  },
  renderHTML({ HTMLAttributes }) {
    console.log('HTMLAttributes', HTMLAttributes)
    return ['sup', HTMLAttributes, 0]
  },
  addNodeView() {
    return ReactNodeViewRenderer(FootnoteComponent)
  },
  addCommands() {
    return {
      setFootnote:
        ({ footnoteNum }) =>
        ({ chain }) => {
          return (
            chain()
              .insertContent({
                type: this.name,
                attrs: { 'data-footnote-num': footnoteNum },
                content: [{ type: 'text', text: footnoteNum.toString() }],
              })
              .command(({ tr, commands }) => {
                const { doc, selection } = tr
                const adjacentNode = doc.nodeAt(selection.to)

                if (adjacentNode === null) {
                  return commands.insertContentAt(selection.to, ' ')
                }

                return commands.command(() => true)
              })
              // set cursor at end of footnote
              .command(({ tr, commands }) => {
                const { doc, selection } = tr

                const position = doc.resolve(selection.to - 2).end()

                return commands.setTextSelection(position)
              })
              .run()
          )
        },
      unsetFootnote:
        () =>
        ({ chain }) =>
          chain().run(),
    }
  },
})
